<template>
  <div class="grid w-full h-full">
    <div class="absolute inset-0 flex justify-center overflow-auto text-sm text-center 2xl:items-center">
      <table v-if="units.length > 0" :class="{ 'animate-pulse': isLoading }">
        <tr>
          <td>
            &nbsp;
          </td>
          <td v-for="n in 15" :key="n" class="p-1">
            {{ n.toString().padStart(2, '0') }}
          </td>
        </tr>
        <tr v-for="floor in units" :key="floor.floor">
          <td class="px-2 py-1 text-right">
            {{ floor.floor.padStart(3, '0') }}
          </td>
          <td
            v-for="unit in floor.units"
            :key="unit.UnitNumber"
            :class="{
              'bg-red-500': ['1', '2', '6'].includes(unit.UnitStatus),
              'bg-green-500': unit.UnitStatus === '0',
              'bg-gray-500': unit.UnitStatus === '3',
              'bg-black': !unit.UnitStatus,
            }"
            class="p-1 text-white "
          >
            {{ unit.UnitNumber }}
          </td>
        </tr>
      </table>
      <div v-else>
        No data were found.
      </div>
    </div>
  </div>
</template>

<script>
import _ from 'lodash'

export default {
  name: 'Matrix',
  data () {
    return {
      units: [],

      timer: undefined,
      isLoading: false,
    }
  },
  activated () {
    this.setTimer()
  },
  mounted () {
    this.fetch()
    this.setTimer()
  },
  methods: {
    async fetch () {
      this.isLoading = true

      try {
        const { data } = await this.$axios.post(process.env.VUE_APP_API_URL, { projectid: process.env.VUE_APP_API_PROJECT_ID })
        const group = _.groupBy(data.data, unit => unit.UnitNumber.match(/^([0-9A]{1,3})/)[1].replace('0', ''))

        this.units = Object.keys(group).map(floor => {
          return {
            floor,
            units: [
              group[floor].find(unit => /(01)$/.test(unit.UnitNumber)) || {},
              group[floor].find(unit => /(02)$/.test(unit.UnitNumber)) || {},
              group[floor].find(unit => /(03)$/.test(unit.UnitNumber)) || {},
              group[floor].find(unit => /(04)$/.test(unit.UnitNumber)) || {},
              group[floor].find(unit => /(05)$/.test(unit.UnitNumber)) || {},
              group[floor].find(unit => /(06)$/.test(unit.UnitNumber)) || {},
              group[floor].find(unit => /(07)$/.test(unit.UnitNumber)) || {},
              group[floor].find(unit => /(08)$/.test(unit.UnitNumber)) || {},
              group[floor].find(unit => /(09)$/.test(unit.UnitNumber)) || {},
              group[floor].find(unit => /(10)$/.test(unit.UnitNumber)) || {},
              group[floor].find(unit => /(11)$/.test(unit.UnitNumber)) || {},
              group[floor].find(unit => /(12)$/.test(unit.UnitNumber)) || {},
              group[floor].find(unit => /(13)$/.test(unit.UnitNumber)) || {},
              group[floor].find(unit => /(14)$/.test(unit.UnitNumber)) || {},
              group[floor].find(unit => /(15)$/.test(unit.UnitNumber)) || {},
            ],
          }
        })

        this.units = _.sortBy(this.units, ['floor'])
      } catch {
        //
      } finally {
        this.isLoading = false

        this.setTimer()
      }
    },
    setTimer () {
      clearInterval(this.timer)
      this.timer = setInterval(() => {
        this.fetch()
      }, 15000)
    },
  },
}
</script>
